export default __webpack_public_path__ + "static/media/moreActions.76869b8e.svg";